import segment from '@bit/fabfitfun.shared.global.analytics';

export const btnLocationEnum = {
  productCard: 'Product Card',
  productAccordion: 'Product Accordion',
  cart: 'Cart',
  learnMore: 'Learn More',
  search: 'Flash Sale Search',
  friendWidget: 'Friend Widget',
  preSalePage: 'Pre-Sale Page',
  saleBanner: 'Sale Banner',
  floatingCTA: 'Floating CTA',
  friendsCart: 'Friends Cart',
};

export const productAvailabilityEnum = {
  outOfStock: 'OOS',
  inStock: 'In Stock',
};

export const segmentEnum = {
  productViewed: 'Product Viewed',
  productAdded: 'Product Added',
  productRemoved: 'Product Removed',
  productFavorited: 'Product Favorited',
  productUnfavorited: 'Product Unfavorited',
  clickedElement: 'Clicked Element',
  searchSubmitted: 'Search Submitted',
  FBProductAdded: 'FB Product Added',
  inviteSent: 'Invite Sent',
  rateAndReview: 'Reviews Accessed',
};

export const ACCOUNT_TRACK_NAMES = {
  started: 'Account Update Started',
  completed: 'Account Update Completed',
};

export const ACCOUNT_SECTIONS = {
  billing: 'Billing Info',
  personal: 'Personal Info',
  shipping: 'Shipping Info',
};

export const ACCOUNT_INFO = {
  payment: 'Payment',
  address: 'Address',
  name: 'Name',
  email: 'Email',
};

export const MY_ACCOUNT_EXPERIENCE = 'my account';

/*
 * catching any errors in the imported track method call
 * and logging them because they should never effect ui
 */
export function track(eventName, trackingData) {
  try {
    const userId = trackingData.user_id && trackingData.user_id.toString();
    const id = { Optimizely: { userId } };
    segment.track(eventName, trackingData, id);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}
